import { useEffect, useRef, useState } from "react";
import { useFormContext } from "react-hook-form";

import KogInputAutoCompleteCheckControlled from "@/main/components/shared/inputAutoCompleteCheck/inputAutoCompleteCheckControlled";
import { isNullUndefined } from "@/main/services/utils";
import { IFormFiltersDynamicExport } from "../modalExportDynamicReport";
import { GeneralVariableType, useDynamicFiltersExport } from "./dynamicFiltersExport";

import { StateApi } from "@/main/api/stateApi";
import { KeyValue } from "@/main/models/common";
import { StateFilterRequest } from "@/main/models/request";

const stateApi = new StateApi();

interface IVariableTypeStateProps extends GeneralVariableType {}

function VariableTypeState({ filter }: IVariableTypeStateProps) {
	const { findFieldIndexByGuidDynamicReportVariable, idScreen, watcherCountry } = useDynamicFiltersExport();

	const { control, setValue } = useFormContext<IFormFiltersDynamicExport>();

	const [optionsState, setOptionsState] = useState<KeyValue[]>([]);
	const [loadingState, setLoadingState] = useState(false);

	const prevCountryRef = useRef<string | null>(null);
	const indexField = findFieldIndexByGuidDynamicReportVariable(filter.guidDynamicReportVariable);

	useEffect(() => {
		if (isNullUndefined(watcherCountry)) return;

		const currentCountryKey = String(watcherCountry.key || "");

		if (prevCountryRef.current !== null && prevCountryRef.current !== currentCountryKey) {
			setValue(`filtersDinamics.${indexField}.value`, []);
			setOptionsState([]);
		}
		prevCountryRef.current = currentCountryKey;

		const request: StateFilterRequest = {
			guidCountry: currentCountryKey,
		};

		setLoadingState(true);

		stateApi
			.getDomain(request)
			.then((res) => {
				const result = res.data.result;

				if (result.length === 0) return;

				if (result.length === 1) {
					setValue(`filtersDinamics.${indexField}.value`, [result[0]]);
				}

				setOptionsState(result);
			})
			.catch((err) => {
				console.error(err);
			})
			.finally(() => {
				setLoadingState(false);
			});
	}, [JSON.stringify(watcherCountry?.key)]);

	const disabledState = isNullUndefined(optionsState) || optionsState.length === 0;

	return (
		<>
			<KogInputAutoCompleteCheckControlled
				name={`filtersDinamics.${indexField}.value`}
				control={control}
				options={optionsState}
				label={filter.responseServer.filterName}
				disabled={disabledState}
				isLoading={loadingState}
				setValueCustom={setValue}
				controllerProps={{
					rules: { required: filter.responseServer.mandatory },
				}}
				customInputProps={{
					required: filter.responseServer.mandatory,
					id: idScreen("select-state"),
				}}
				onChangeCustom={() => {}}
			/>
		</>
	);
}

export default VariableTypeState;
